import { render, staticRenderFns } from "./joint-cooperation-config-dialog.vue?vue&type=template&id=6724d09b&scoped=true"
import script from "./joint-cooperation-config-dialog.vue?vue&type=script&lang=js"
export * from "./joint-cooperation-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./joint-cooperation-config-dialog.vue?vue&type=style&index=0&id=6724d09b&prod&lang=scss&scoped=true"
import style1 from "./joint-cooperation-config-dialog.vue?vue&type=style&index=1&id=6724d09b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6724d09b",
  null
  
)

export default component.exports